module.exports = __webpack_public_path__ + "static/media/kaoPineda2020_manuscript.7cc2154b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/papers/kaoPineda2020_manuscript.pdf
// module id = 143
// module chunks = 0